import { getCompId, getInstance, getOrigCompId } from '../../../../utils';

// @ts-ignore
import { SETTINGS_DATA_URL } from '../../config/constants';

const IS_DEV = (process.env.NODE_ENV as string) === 'development';
const isLocalServer = false;

const domain = !IS_DEV
  ? 'google-calendar.galilcloud.wixapps.net'
  : isLocalServer
  ? 'calendar-server-api.wixapps.codev.co.il'
  : 'calendar-server-dev.codev.co.il';

export const getSettingsApiUrl = (params) => {
  const compId = getOrigCompId();
  const apiUrl = new URL(`${SETTINGS_DATA_URL}`);
  apiUrl.searchParams.set('compId', compId);
  apiUrl.searchParams.set('instance', getInstance());

  Object.entries(params).forEach(([key, value]) => {
    apiUrl.searchParams.set(key, value + '');
  });
  return apiUrl;
};

type ApiEndpoints =
  | 'disconnect'
  | 'getCalendarsList'
  | 'updateUserSetting'
  | 'getEvents'
  | 'getRecurrence'
  | 'eventsByDates'
  | 'getSettings';

export const getApiUrl = (
  endpoint: ApiEndpoints,
  params,
  originCompId?: string,
  useApiPrefix: boolean = true,
) => {
  const compId = originCompId || getCompId();
  const apiUrl = new URL(
    `https://${domain}${useApiPrefix ? '/_api' : ''}/${endpoint}`,
  );
  apiUrl.searchParams.set('compId', compId);
  apiUrl.searchParams.set('instance', getInstance());

  Object.entries(params).forEach(([key, value]) => {
    apiUrl.searchParams.set(key, value + '');
  });

  return apiUrl;
};

export const fetchApi = async (url: URL, options: RequestInit = {}) => {
  try {
    const response = await fetch(url.toString(), options);
    console.log('>> fetchApi = ', response);
    return await response.json();
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const fetchMultipleApis = async (urls: URL[]) => {
  const requests = urls.map((url) => fetchApi(url));
  return Promise.all(requests);
};

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchApiWithRetry = async (url: URL, type: 'eventsByDates') => {
  let res = await fetchApi(url);

  while (res.error) {
    await delay(200); // Wait for 200ms
    res = await fetchApi(url);
    console.log('>>> queries per minute per user quota exceeded');
  }
  return res;
};
